import React from 'react';
import { Instagram, Globe } from 'lucide-react';
import { Section, Eyebrow, H2, Reveal, FONT, MONO } from './ui';

export const Closing = ({ d, L, t, bio, video }) => (
  <>
    <Section id="assignment" dark>
      <div className="grid lg:grid-cols-[1fr_1.3fr] gap-12">
        <Reveal><Eyebrow dark>{L(d.assignment.eyebrow)}</Eyebrow><H2 dark className="mt-4">{L(d.assignment.title)}</H2><p className="mt-6 text-sm text-blue-100/60">{L(d.assignment.note)}</p></Reveal>
        <Reveal delay={120}>
          <ol className="space-y-3" data-testid="assignment-steps">
            {L(d.assignment.steps).map((s, i) => (
              <li key={s} className="flex gap-5 items-start rounded-2xl border border-white/10 bg-white/[0.03] p-5">
                <span className="text-3xl font-extrabold text-blue-400 w-8" style={FONT}>{i + 1}</span><span className="text-blue-50 pt-1">{s}</span>
              </li>
            ))}
          </ol>
        </Reveal>
      </div>
    </Section>
    <Section id="takeaways">
      <Reveal><Eyebrow>Takeaways</Eyebrow><H2 className="mt-4">{L(d.takeaways.title)}</H2></Reveal>
      <div className="mt-12 grid md:grid-cols-3 gap-0 rounded-[2rem] overflow-hidden border border-slate-200" data-testid="takeaways">
        {d.takeaways.items.map((x, i) => (
          <Reveal key={i} delay={i * 120} className="h-full">
            <div className={`h-full p-10 ${['bg-white', 'bg-blue-600 text-white', 'bg-[#060d24] text-white'][i]}`}>
              <p className="text-3xl lg:text-4xl font-extrabold leading-tight" style={FONT}>{L(x.title)}</p>
              <p className={`mt-4 ${i ? 'text-white/80' : 'text-slate-600'}`}>{L(x.body)}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </Section>
    <Section id="speaker" className="bg-slate-50">
      <div className="grid lg:grid-cols-[1fr_1.4fr] gap-12 items-start" data-testid="speaker-bio-card">
        <Reveal>
          <video src={video} autoPlay muted loop playsInline className="w-full h-[360px] object-cover rounded-[2rem] border-4 border-white shadow-xl" data-testid="speaker-video-embed" />
        </Reveal>
        <Reveal delay={120}>
          <Eyebrow>{t.speaker}</Eyebrow>
          <H2 className="mt-4">{d.speaker.name}</H2>
          <div className="mt-4 flex flex-wrap gap-2">{L(d.speaker.roles).map((r) => <span key={r} className="px-3 py-1.5 rounded-full bg-white border border-slate-200 text-xs font-semibold text-slate-700">{r}</span>)}</div>
          {bio.map((b) => <p key={b} className="mt-5 text-slate-600">{b}</p>)}
          <div className="mt-6 flex flex-wrap gap-3">
            {d.links.map((l) => (
              <a key={l.url} href={l.url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-4 py-2 rounded-xl bg-white border border-slate-300 font-semibold text-sm hover:border-blue-500 transition-colors" data-testid={`speaker-link-${l.label.includes('@') ? 'instagram' : 'site'}`}>
                {l.label.includes('@') ? <Instagram className="w-4 h-4" /> : <Globe className="w-4 h-4" />} {l.label}
              </a>
            ))}
          </div>
        </Reveal>
      </div>
    </Section>
  </>
);

export const Thanks = ({ d, L, t }) => (
  <section className="bg-[#040919] text-white text-center py-24 px-5" data-testid="section-thanks">
    <p className="text-xs uppercase tracking-[0.3em] text-blue-300" style={MONO}>{t.questions}</p>
    <p className="mt-4 text-5xl sm:text-7xl font-extrabold" style={FONT}>{t.thankYou}</p>
    <p className="mt-6 text-blue-100/80 max-w-2xl mx-auto">{L(d.thanks)}</p>
    <p className="mt-8 text-sm text-blue-200/60">{d.speaker.name} · vocalfitness.org · Instagram @dappersclass</p>
  </section>
);
